// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__T3GSa","focused-content":"Overlay_focused-content__JuNS_"};